import { api } from '../../api/client';
import { useApi } from '../../hooks/useApi';
import { Btn, EmptyState } from '../ui';

// The Mail and Calendar pages share ONE connect gate: both read the same
// dbo.UserGraphConnections row (My Settings → Connected Accounts → "Mail &
// Calendar") that Harvi's own mail/calendar tools use, so "are we connected"
// and what to say about it must not drift between two copies of this check.
export function usePersonalConnectStatus() {
  return useApi(() => api.get('personal/status'), []);
}

export const NotConnectedCard = ({ feature, status, setPage }) => (
  <EmptyState
    icon="mail"
    title={status?.configured === false ? 'Not available on this deployment' : 'Connect your Microsoft account'}
    message={status?.configured === false
      ? `An administrator has to grant Harvus the delegated Microsoft permissions before ${feature} can be used.`
      : `Harvus ${feature} works through your own Outlook account. Connect it once from My Settings.`}
    action={status?.configured !== false && <Btn onClick={() => setPage?.('userSettings')}>Go to My Settings</Btn>}
  />
);
